import { put, delay } from 'redux-saga/effects';
import * as actions from '../actions';
import { get, post } from '../../utils/api';
import { handleError } from '../../utils/errors';
import GrapeFormat from '../../utils/formatters/formik-grape-formatter';


export function* fetchStoriesSaga(action) {
  const { brandProfileId, fromId } = action;
  try {
    const response = yield get(
      `/api/v1/brand_profiles/${brandProfileId}/staffers/${fromId}/assigned_stories`
    );
    yield put(actions.setStories(response));
  } catch (error) {
    yield handleError(error);
  }
}

export function* fetchEligibleUsersSaga(action) {
  try {
    const query = '?category=stories&capability=assignable';
    const response = yield get(`/api/v1/brand_profiles/${action.brandProfileId}/staffers${query}`);
    yield put(actions.setEligibleUsers(response));
  } catch (error) {
    yield handleError(error);
  }
}

export function* handleJobRestartSaga(action) {
  const {
    jobId,
    brandProfileId,
    fromUser,
    toUser
  } = action;
  try {
    const response = yield get(`/api/v1/batches/${jobId}`);
    if (!response.isComplete) {
      yield put(actions.handleJobId(jobId, brandProfileId, fromUser, toUser));
      yield put(actions.fetchStories(brandProfileId, fromUser.value));
    } else {
      yield put(actions.removePersistedJobStatus());
    }
  } catch (error) {
    yield handleError(error);
  }
}

export function* handleJobIdSaga(action) {
  const {
    jobId,
    brandProfileId,
    fromUser,
    toUser
  } = action;
  yield put(actions.setJobId(jobId));
  yield put(actions.setPersistedJobStatus(jobId, fromUser, toUser));
  yield put(actions.handlePollingJobStatus(jobId, brandProfileId, fromUser.value));
}

export function* startReassignmentJobSaga(action) {
  const { brandProfileId, fromUser, toUser } = action;
  try {
    const response = yield post(
      `/api/v1/brand_profiles/${brandProfileId}/reassign_users`,
      JSON.stringify(
        GrapeFormat({
          fromUserId: fromUser.value,
          toUserId: toUser.value
        })
      )
    );

    yield put(actions.handleJobId(response.data.id, brandProfileId, fromUser, toUser));
  } catch (error) {
    yield handleError(error);
  }
}

export function* handlePollingJobStatusSaga(action) {
  const { jobId, brandProfileId, fromId } = action;
  try {
    const response = yield get(`/api/v1/batches/${jobId}`);
    yield put(actions.setJobStatus(response));

    if (!response.isComplete) {
      yield delay(1000);
      yield put(actions.handlePollingJobStatus(jobId, brandProfileId, fromId));
    } else {
      yield put(actions.removePersistedJobStatus());
      yield put(actions.fetchStories(brandProfileId, fromId));
    }
  } catch (error) {
    yield handleError(error);
  }
}



// WEBPACK FOOTER //
// ./app/javascript/app/store/sagas/reassign_users.js